import React, { useMemo, useState } from 'react';
import { getControlStyle, setImage } from '../../helper';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';
import noImage from '../../../assets/images/no-image.png';

export function TestingControl(props) {
  const { fromForm, dataIndex, editingInput, deleteItem, testGroup, values, fromProduct, dppAddEditAccess, isProductArchived } = props;
  const [expandedGroup, setExpandedGroup] = useState(null);

  const handleToggleExpandGroup = (groupId) => {
    setExpandedGroup((prev) => (prev === groupId ? null : groupId));
  };

  const handleImageError = (event) => {
    event.target.src = noImage;
  };

  function determineAllStatus(data) {
    const statuses = data?.map((item) => item.status);
    const allTrue = statuses?.every((status) => status === true || status === 'true');
    const allFalse = statuses?.every((status) => status === false || status === 'false');
    const allPending = statuses?.every((status) => status === 'pending');
    const hasTrue = statuses?.includes(true) || statuses?.includes('true');
    const hasFalse = statuses?.includes(false) || statuses?.includes('false');
    const hasPending = statuses?.includes('pending');

    if (allPending) {
      return 'Pending';
    }
    if (allTrue) {
      return 'Approved';
    }
    if (allFalse) {
      return 'Rejected';
    }
    if (hasPending && hasFalse && !hasTrue) {
      return 'Mixed-Rejected';
    }
    if (hasPending && hasTrue && !hasFalse) {
      return 'Mixed-Approved';
    }
    if (hasTrue && hasFalse && !hasPending) {
      return 'Approved-Rejected';
    }
    if (hasTrue && hasFalse && hasPending) {
      return 'Mixed-All';
    }
    return 'Mixed';
  }

  const verticalReject = 'vertical-bar sts-reject';
  const verticalPending = 'vertical-bar sts-pending';
  const verticalApprove = 'vertical-bar sts-approve';

  function getStatusClass(concatenatedTestings) {
    if (!fromProduct) {
      return verticalPending;
    }

    const status = determineAllStatus(concatenatedTestings);
    switch (status) {
      case 'Rejected':
        return verticalReject;
      case 'Approved':
        return verticalApprove;
      case 'Mixed-Rejected':
        return 'vertical-bar sts-pending';
      case 'Mixed-Approved':
        return 'vertical-bar sts-pending';
      case 'Approved-Rejected':
        return 'vertical-bar sts-pending';
      case 'Mixed-All':
        return 'vertical-bar sts-pending';
      default:
        return verticalPending;
    }
  }
  const emptyTestiing = useMemo(() => {
    if (!fromProduct) {
      if (testGroup?.length === 1) {
        if (!testGroup?.[0]?.testGroupTitle) {
          return true;
        }
      }
    }
    return false;
  }, [fromProduct, testGroup]);

  const getClassName = (filteredData) => {
    if (filteredData?.length > 0) {
      return filteredData[filteredData.length - 1]?.status === true || filteredData[filteredData.length - 1]?.status === 'true'
        ? 'vertical-bar sts-approve'
        : 'vertical-bar sts-reject';
    }
    return 'vertical-bar sts-pending';
  };

  return (
    <div className="testing-control">
      {emptyTestiing ? (
        <div className="empty-testing">
          <span className="title">Title Placeholder</span>
          <div className="image-container">
            <i className="icon icon-DAM-1" />
          </div>
        </div>
      ) : (
        testGroup?.map((gr, index) => {
          const isGroupExpanded = expandedGroup === index;
          const testAutoId = fromProduct ? gr?.testGroupType?.map((type) => type?.testTypeAuto?.map((tes) => tes?._id)).flat() : [];
          const matchingId = fromProduct ? values?.filter((item) => testAutoId?.includes(item.testTypeId)) : [];
          const concatenatedTestings = fromProduct
            ? matchingId?.reduce((acc, item) => {
                return acc?.concat(item.testings);
              }, [])
            : [];
          return (
            <div key={gr?.testGroupTitle} className="group-container">
              <div className="basic-details" onClick={() => handleToggleExpandGroup(index)}>
                <span className={getStatusClass(concatenatedTestings)} />
                <div className="group-header clickable">
                  <p className="group-title">
                    {gr?.testGroupTitle}
                    <span id="collapsible-testing" className={`icon-new-down-arrow-icon drop-icon ml-3 mr-4 ${isGroupExpanded ? 'rotated' : ''}`} />
                  </p>
                </div>
                <figure>
                  <img src={gr?.testIconImage ? setImage(gr?.testIconImage) : noImage} alt="" className="img-fluid" onError={handleImageError} />
                </figure>
              </div>

              <div id="testing-details" className={isGroupExpanded ? 'd-block group-details' : 'd-none'}>
                {fromProduct
                  ? gr?.testGroupType?.map((teType, chi) => {
                      const combinedStyles = getControlStyle(teType?.otherConfiguration, 'alignment', 'colour', 'bold');
                      const combinedDesStyles = getControlStyle(
                        teType?.descriptionConfiguration?.otherConfiguration,
                        `descAlignment_${index}_${chi}`,
                        `descColour_${index}_${chi}`,
                        `descBold_${index}_${chi}`,
                      );

                      if (teType?.testTypeAuto?.length) {
                        return teType?.testTypeAuto?.map((tesDesc) => {
                          const matchingValue = values?.find((val) => val?.testTypeId === tesDesc?._id);
                          const filteredData = matchingValue?.testings?.filter((data) => {
                            const status = data?.status;
                            return status === true || status === 'true' || status === false || status === 'false';
                          });
                          return (
                            <div key={tesDesc?._id} className="test-type-container">
                              <span className={getClassName(filteredData)} />
                              <p style={combinedStyles} className="test-description">
                                {tesDesc?.name}
                              </p>
                              <div className="additional-details">
                                <p className="result-data" style={combinedDesStyles}>
                                  {(() => {
                                    if (filteredData?.length > 0) {
                                      const latestData = filteredData[filteredData.length - 1];
                                      if ((latestData?.status === true || latestData?.status === 'true') && tesDesc?.approvalActive) {
                                        return tesDesc?.approvalDescription || latestData?.result;
                                      }
                                      if ((latestData?.status === false || latestData?.status === 'false') && tesDesc?.rejectActive) {
                                        return tesDesc?.rejectDescription || latestData?.result;
                                      }
                                    }
                                    return null;
                                  })()}
                                </p>
                              </div>
                            </div>
                          );
                        });
                      }
                    })
                  : gr?.testGroupType?.map((teType) => {
                      const combinedStyles = getControlStyle(teType?.otherConfiguration, 'alignment', 'colour', 'bold');
                      if (teType?.testTypeAuto?.length) {
                        return teType?.testTypeAuto?.map((tesDesc) => {
                          return (
                            <div key={tesDesc?.name} className="test-type-container">
                              <span className="vertical-bar sts-pending" />
                              <p style={combinedStyles}>{tesDesc?.name}</p>
                            </div>
                          );
                        });
                      }
                    })}
              </div>
            </div>
          );
        })
      )}
      {fromForm && (
        <CommonAction
          editingInput={editingInput}
          deleteItem={deleteItem}
          dataIndex={dataIndex}
          dppAddEditAccess={dppAddEditAccess}
          isProductArchived={isProductArchived}
        />
      )}
    </div>
  );
}
export default TestingControl;
